<template>
  <v-container class="ma-0">
    <template>
      <v-card class="mt-2">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
          <v-spacer/>
           <v-btn
        icon
        @click="showFilters = !showFilters"
      >
        <v-icon>{{ showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
        </v-card-title>
          <v-expand-transition>
      <div v-show="showFilters">
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4">
              <v-select
                v-model="vehicleMake"
                :items="uniqueVehicles"
                prepend-icon="mdi-truck"
                label="Μαρκα Όχημα"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(vehicle, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                v-model="vehicle"
                :items="vehicleTypes"
                label="Σήμανση"
                prepend-icon="mdi-clipboard-alert"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
            </v-col>
          </v-row>
        </v-card-text>
     </div>
    </v-expand-transition>
      </v-card>
    </template>

  <template>
  <v-card class="mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Οχήματα</h1>
          <v-btn
            color="blue darken-1"
            icon
            @click="refreshVehicles"
          >
          <v-icon>mdi-refresh</v-icon>
          </v-btn>

      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
        <v-spacer></v-spacer>
        <new-vehicle-dialog :cid="$store.customer.Cid"/>
    </v-card-title>
    <v-data-table
      :headers="showHeaders"
      :items="vehicles"
      :search="search"
      loading: false
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click.stop="showdialog(item)"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
        <v-btn
          icon
          :to="'/vehicle/details/'+item.Id"
        >
         <v-icon>mdi-file-document</v-icon>
        </v-btn>
        <new-repair useIcon="1" :VehId="item.Id"/>
     </template>

     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.Id }}
      </td>
    </template>


   <template v-slot:no-data>
          <span>Δεν βρέθηκαν οχήματα συσχετισμένα με τον πελάτη</span>
        </template>

    </v-data-table>
  </v-card>
</template>
</v-container>

</template>

<script>
import {uniq as _uniq} from "lodash";
import NewVehicleDialog from "../../components/NewVehicleDialog.vue";
import NewRepair from "../../components/NewRepair.vue";


export default {
  components: {
     NewVehicleDialog,
     NewRepair,
  },
  computed: {
    uniqueVehicles () {
      return _uniq(this.vehicles.map(({Make}) => Make ));
    },
    vehicleTypes () {
      return _uniq(this.vehicles.map(({VehType}) => VehType ));
    },
    showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(['Year', 'Vin']).includes(h.value));
        } else {
            return this.headers;
        }
    },
    
  },
  data() {
    return {
      expanded: [],
      vehicleMake: [],
      loading: true,
      search: '',
      customer_id: this.$route.params.id,
      vehicle: '',
      showFilters: false,
      vehicles: [],
      headers: [
          {
            text: 'Α/A',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '8%',
          },
          { text: 'Έτος', value: 'Year', width: '10%' },
          { text: 'Τυπος', value: 'VehType',
          filter: (value) => {
            if (this.vehicle.length == 0) return true;
            return this.vehicle.includes(value);
          }},
          { text: 'Κατασκευαστής', value: 'Make',
            filter: (value) => {
              if (this.vehicleMake.length == 0) return true;
              return this.vehicleMake.includes(value);
            }},
          { text: 'Αριθμός Πλαισίου', value: 'Vin', width: '20%' },
          { text: 'Οχημα', value: 'PlateNumber'},
          { text: 'Actions', value: 'actions' },
         // { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/customers/vehicles/'+this.$route.params.id, {params: { 'non-billing': true }});
        this.vehicles = response.data;

        // const resp = await this.$api.get('/customers/'+this.$route.params.id);
        // this.customer = resp.data;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
    async refreshVehicles() {
        const response = await this.$api.get('/customers/vehicles/'+this.$route.params.id,
         {
             params: { 'non-billing': true },
             clearCache: true         
         });
        this.vehicles = response.data;
    },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },

  }
}
</script>
